import { render, staticRenderFns } from "./JoinOrganization.vue?vue&type=template&id=5c5fda47&scoped=true&"
import script from "./JoinOrganization.vue?vue&type=script&lang=js&"
export * from "./JoinOrganization.vue?vue&type=script&lang=js&"
import style0 from "./JoinOrganization.vue?vue&type=style&index=0&id=5c5fda47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5fda47",
  null
  
)

export default component.exports